import { Run, RunStatus, StatusCode } from '../models/run';
import { LogLevel } from '../models/runLog';
import { runsQuerySchema, runsSchema } from './runs.schema';

export type RunsQuery = {
  timestampAfter?: string;
  timestampBefore?: string;
  search?: string;
  hook?: Array<number>;
  requestId?: string;
  /** @deprecated logLevel will be removed along with Logs screen removal */
  logLevel?: LogLevel;
  statusCode?: Array<StatusCode>;
  queue?: Array<string>;
  annotation?: Array<string>;
  email?: Array<string>;
  pageSize?: number;
  status?: RunStatus;
};

// TODO: can be removed once we use listResponse and response has pagination, use `ListResponse<Run>`
// https://rossumai.atlassian.net/browse/MAT-145
export type Runs = { results: Array<Run> };

export const runs = (query: RunsQuery = {}) => {
  return {
    endpoint: `/hooks/runs`,
    method: 'GET',
    responseSchema: runsSchema,
    query,
    querySchema: runsQuerySchema,
  } as const;
};
